module.exports = __webpack_public_path__ + "static/media/00000212.5323d604.jpg";